import { useEffect } from 'react'
import { com } from '@eidu/web'
import PermissionError from '../../PermissionError'
import EntityFieldInputGroup from '../shared/EntityFieldInputGroup'
import PageLayout from '../shared/PageLayout'
import useEntityEdit from '../shared/useEntityEdit'
import { KindEditPageProps } from '../KindPages'
import computeLabel from '../shared/computeLabel'
import LearningUnitEditorWrapper from '../../../../ui/microfrontend/LearningUnitEditorWrapper'
import Link from '../../../../domain/entity/Link'
import linkKeyFromString = com.eidu.sharedlib.entity.link.linkKeyFromString

const LearningUnitEditPage = ({ entity, entityId, entityType, entityTypes, loading }: KindEditPageProps) => {
  const {
    fields,
    updateField,
    submitting,
    valid,
    submitEntity,
    deleteEntity,
    hasPermissions,
    permissionsLoading,
    registerValidation,
    registerPreSubmit,
  } = useEntityEdit({
    entity,
    entityId,
    entityType,
  })

  const handleRegisterPartialSubmit = (fn: () => Promise<Link[]>) => {
    registerPreSubmit(fn)
  }

  useEffect(() => {
    registerValidation(() => true)
  }, [registerValidation])

  if (!hasPermissions && !loading && !permissionsLoading) {
    return <PermissionError missingPermittedActions={[]} />
  }

  const label = computeLabel(entityType, fields)

  return (
    <PageLayout
      title={label ?? entityType.name}
      subtitle={label ? entityType.name : undefined}
      showCancel
      showSave
      showDelete={!!entity}
      saveDisabled={!valid}
      submitting={submitting}
      onSave={submitEntity}
      onDelete={deleteEntity}
    >
      <EntityFieldInputGroup
        entityType={entityType}
        entityTypes={entityTypes}
        fields={fields}
        updateField={updateField}
        loading={loading}
      />
      {entity && (
        <LearningUnitEditorWrapper
          entityId={entity.entity.id.toString()}
          entityLinks={[...(entity.entity.links.asJsReadonlyMapView().entries() || [])].map(([key, value]) => ({
            key,
            value,
          }))}
          linkKeyFromString={linkKeyFromString}
          onRegisterPartialSubmit={handleRegisterPartialSubmit}
          mode="edit"
        />
      )}
    </PageLayout>
  )
}

export default LearningUnitEditPage
